export interface IMetatagService {
    get(name: string): string;
}

export class MetatagService implements IMetatagService {
    get(name: string): string {
        let result = "";
        const metas = document.getElementsByTagName('meta');

        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute("name") === name)
                result = metas[i].getAttribute("content");
        }

        return result;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/metatagService.ts
 **/